import { convertDate } from '@/services/convert'

export default {
  props: ['list'],
  data: function() {
    return {
      notes: this.list,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      convertDate: convertDate,
    }
  },
  watch: {
    list() {
      this.notes = [...this.list]
    },
  },
}
